// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { Metric } from 'statsradio/themes/v3/Stylesheet';
import IncreaseDecreasePercent, { calculateIncreaseDecreasePercent } from 'statsradio/components/IncreaseDecreasePercent';
import { MetricVariation, CurrentMetric } from './Metric';
import type { ComparedMetric } from '../../../domain/DashboardData';

const VerticalContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  white-space: nowrap;
`;

const Day = styled.h4`
  padding-bottom: ${props => props.theme.V3.metrics.margin.normal}px;
`;

interface Props {
  day: string,
  metric: ComparedMetric,
  type: string,
  t: any,
}

function SingleDayMetric({ day, type, metric, t }: Props) {
  return (
    <VerticalContainer>
      <Day>{day}</Day>
      <VerticalContainer>
        <Metric>
          <IncreaseDecreasePercent
            percent={calculateIncreaseDecreasePercent(metric)}
            iconSize={{ width: 20, height: 20 }}
          />
        </Metric>
        <CurrentMetric type={type} value={metric.current} />
        <MetricVariation type={type} value={metric.current - metric.compared} showPlusSign />
      </VerticalContainer>
    </VerticalContainer>
  );
}

export default translate('dashboard')(SingleDayMetric);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/audienceComparison/SingleDayMetric.js